

import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './login/Login';
import Layout from './Manager/Layout';
import ManagementDashboard from './Manager/Management';
import DashboardSidebar from './Manager/DashboardSidebar';
import SignUp from './login/SignUp';
import BrokerLayout from './Broker/BrokerLayout';
import ManagerBrokerForm from './Manager/ManagerBrokerForm';
import AdminLayout from './Admin/AdminLayout';
import ManageBroker from './Manager/ManageBroker';
import ManageManager from './Admin/ManageManager';
import BrokerFormPage from './Forms/BrokerForm/BrokerFormPage';
import AdminProfile from './Admin/AdminProfile';
import ManagerProfile from './Manager/ManagerProfile';
import BrokerProfile from './Broker/BrokerProfile';
import BrokerDashbord from './Broker/BrokerDashbord';
import AssignForm from './Manager/AssignForm';
import ManagerDashboard from './Manager/ManagerDashboard';
import Submission from './Manager/Submission';

import SetPasswordScreen from './screens/SetPasswordScreen';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen';
import ResetPasswordScreen from './screens/ResetPasswordScreen';
import SubmissionHistoryViewer from './Forms/BrokerForm/SubmissionHistoryViewer';
import AmanageBroker from './Admin/AmanageBroker';
import AmanagerDashboard from './Admin/AmanagerDashboard';
import AassignForm from './Admin/AassignForm';
import Asubmission from './Admin/Asubmission';


function App() {
  const [, setIsLoggedIn] = useState(false);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/set-password/:token" element={<SetPasswordScreen />} />
        <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
        <Route path="/reset-password/:token" element={<ResetPasswordScreen />} />
        <Route element={<Layout />}>
          <Route path="/Manager/sidebar" element={<DashboardSidebar />} />
          <Route path="/Manager/ManageBroker" element={<ManageBroker />} />
          <Route path="/management" element={<ManagementDashboard />} />
          <Route path="/ManagerBrokerForm" element={<ManagerBrokerForm />} />
          <Route path="/Manager/ManagerProfile" element={<ManagerProfile />} />
          <Route path="/Manager/ManagerAssignForm" element={<AssignForm/> } />
          <Route path="/Manager/ManagerDashboard" element={<ManagerDashboard/> } />
          <Route path="/Manager/SubmissionHistoryViewer" element={<SubmissionHistoryViewer />} />
          <Route path="/Manager/form/:formId" element={<BrokerFormPage />} />
          <Route path="/Manager/Submission" element={<Submission />} />
        </Route>
        <Route path="/broker" element={<BrokerLayout />}>
          <Route path="dashboard" element={<BrokerDashbord />} />
          <Route path="form/:formId" element={<BrokerFormPage />} />
          <Route path="profile" element={<BrokerProfile />} />
        </Route>
        <Route element={<AdminLayout />}>
          <Route path="/admin/manage-managers" element={<ManageManager />} />
          <Route path="/admin/manage-brokers" element={<AmanageBroker/>} />
          <Route path="/admin/invoice" element={<div>Invoice Content</div>} />
          <Route path="/admin/profile" element={<AdminProfile />} />
          <Route path="/admin/AmanagerDashboard" element={<AmanagerDashboard />} />
          <Route path="/admin/AassignForm" element={<AassignForm/>} />
          <Route path="/admin/Asubmission" element={<Asubmission />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;